import { lazy } from 'react'

import { t } from 'i18next'

export const CurricularUnits = [
  {
    name: t('curricular-units:exportTitle'),
    component: lazy(() => import('../../modules/common/CurricularUnitExporter')),
    path: '/coordinator/curricular-units/export',
    guards: ['allowOnlyCoordinator', 'allowOnlyLogged'],
  },
]
